import React from "react";
import "./Footer.css";
import image1 from "../../Images/Group.png";
import { Link } from "react-router-dom";
import { TiSocialLinkedin, TiSocialYoutube, TiSocialFacebook } from "react-icons/ti";
import { AiOutlineX } from "react-icons/ai";
const Footer = () => {
  return (
    <div className="md:!px-42 w-full text-white">
      <div>
        <div>
          <Link to="/">
            <img src={image1} alt="logo" className="!w-[10rem] md:w-[15rem]" />
          </Link>
        </div>
        <div className="md:flex text-center md:text-left">
          <div className="!mt-5 md:basis-1/2 text-left">
            <h1 className="text-[16px] md:text-[25px]">We're Just a Message Away!</h1>
            <div className="flex !gap-5 !mt-5 justify-start md:justify-start">
              <a
                href="https://x.com/Owision_SE"
                target="_blank"
                rel="noreferrer"
                className="relative top-[5px]"
              >
                <AiOutlineX size={14} />
              </a>
              <a href="https://www.linkedin.com/company/owision/" target="_blank" rel="noreferrer">
                <TiSocialLinkedin size={24} />
              </a>
              <a href="https://www.youtube.com/@Owision" target="_blank" rel="noreferrer">
                <TiSocialYoutube size={24} />
              </a>
              <a
                href="https://www.facebook.com/people/Owision/100038170186076/"
                target="_blank"
                rel="noreferrer"
              >
                <TiSocialFacebook size={24} />
              </a>
            </div>
          </div>
          <div className="text-white md:!basis-1/2 text-left">
            <div className="flex justify-around !gap-20">
              <div className="footer-item-list">
                <ul>
                  <h1 className="!mt-5 md:!mt-0 text-[20px] md:text-[22px] font-semibold md:!mb-5">
                    Company
                  </h1>
                  <li className="text-[12px] md:text-[16px]">
                    <a href="/about">About Us</a>
                  </li>
                  <li className="text-[12px] md:text-[16px]">
                    <a href="/service">Services</a>
                  </li>
                  <li className="text-[12px] md:text-[16px]">
                    <a href="/privacy-policy">Privacy policy</a>
                  </li>
                </ul>
              </div>
              <div className="footer-item-list responsive-list">
                <ul>
                  <h1 className="!mt-5 md:!mt-0 text-[20px] md:text-[22px] font-semibold md:!mb-5">
                    Resources
                  </h1>
                  <li className="text-[12px] md:text-[16px]">
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
